import config from '../utils/ApiUrl';
import { getCookie, handleSessionExpire } from './session';

const API_URL = config.API_URL;

const userLogin = async (formdata) => {
  try {
    const response = await fetch(`${API_URL}/admin-login`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(formdata),
    });
    return response.json();
  } catch {
    throw new Error('Failed to Login');
  }
};

const fetchAllUsers = async (password) => {
  const sessionToken = getCookie();
  if (!sessionToken) return handleSessionExpire();

  const response = await fetch(`${API_URL}/admin-fetch-users/${password}`, {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${sessionToken}`,
    },
  });
  const data = await response.json();
  return data;
};

const blockUser = async (formdata) => {
  const sessionToken = getCookie();
  if (!sessionToken) return handleSessionExpire();

  const response = await fetch(`${API_URL}/admin-user-block`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${sessionToken}`,
    },
    body: JSON.stringify(formdata),
  });
  const data = await response.json();
  return data;
};

const whitelistUser = async (formdata) => {
  const sessionToken = getCookie();
  if (!sessionToken) return handleSessionExpire();

  const response = await fetch(`${API_URL}/admin-user-whitelist`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${sessionToken}`,
    },
    body: JSON.stringify(formdata),
  });
  const data = await response.json();
  return data;
};

const adminLogout = async () => {
  const sessionToken = getCookie();
  if (!sessionToken) return { success: false, message: 'No session found' };

  try {
    const response = await fetch(`${API_URL}/admin-logout`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${sessionToken}`,
      },
    });
    const data = await response.json();
    return data;
  } catch (error) {
    console.error('Logout API error:', error);
    return { success: false, message: 'Logout failed' };
  }
};

const scheduleDeleteUser = async (formdata) => {
  const sessionToken = getCookie();
  if (!sessionToken) return handleSessionExpire();

  const response = await fetch(`${API_URL}/admin-user-schedule-delete`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${sessionToken}`,
    },
    body: JSON.stringify(formdata),
  });
  const data = await response.json();
  return data;
};

const forceDeleteUser = async (formdata) => {
  const sessionToken = getCookie();
  if (!sessionToken) return handleSessionExpire();

  const response = await fetch(`${API_URL}/admin-user-force-delete`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${sessionToken}`,
    },
    body: JSON.stringify(formdata),
  });
  const data = await response.json();
  return data;
};

const requestGiftSubscription = async (formdata) => {
  const sessionToken = getCookie();
  if (!sessionToken) return handleSessionExpire();

  const response = await fetch(`${API_URL}/admin-gift-subscription-request`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${sessionToken}`,
    },
    body: JSON.stringify(formdata),
  });
  const data = await response.json();
  return data;
};

const verifyGiftSubscription = async (formdata) => {
  const sessionToken = getCookie();
  if (!sessionToken) return handleSessionExpire();

  const response = await fetch(`${API_URL}/admin-gift-subscription-verify`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${sessionToken}`,
    },
    body: JSON.stringify(formdata),
  });
  const data = await response.json();
  return data;
};

const revokeGiftSubscription = async (formdata) => {
  const sessionToken = getCookie();
  if (!sessionToken) return handleSessionExpire();

  const response = await fetch(`${API_URL}/admin-gift-subscription-revoke`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${sessionToken}`,
    },
    body: JSON.stringify(formdata),
  });
  const data = await response.json();
  return data;
};

export { userLogin, fetchAllUsers, blockUser, whitelistUser, adminLogout, scheduleDeleteUser, forceDeleteUser, requestGiftSubscription, verifyGiftSubscription, revokeGiftSubscription };
